__turbopack_context__.v({
  "container": "style-module-scss-module__unsHmq__container",
  "content": "style-module-scss-module__unsHmq__content",
  "divider": "style-module-scss-module__unsHmq__divider",
  "story": "style-module-scss-module__unsHmq__story",
  "text": "style-module-scss-module__unsHmq__text",
});
